import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Roboto', sans-serif;
    background-color: #FBFAF7;
    color: #1A1A1A;
    line-height: 1.6;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Playfair Display', serif;
    color: #1A1A1A;
    font-weight: 600;
  }

  p, span, div, a, button, input, select, textarea {
    font-family: 'Roboto', sans-serif;
  }
`;

export const colors = {
  primary: '#B5502F', // Terracotta - unico accento (CTA, stati attivi/selezionati)
  secondary: '#E4DFD3', // Hairline chiaro (bordi sottili, sfondi neutri)
  accent: '#8C3D22', // Terracotta scuro (hover, notifiche)
  white: '#FFFFFF', // Bianco puro
  cream: '#FBFAF7', // Crema quasi bianco
  brown: '#1A1A1A', // Inchiostro (testo principale)
  lightBrown: '#6B6B6B', // Grigio caldo per testi secondari
  darkRed: '#8C3D22', // Hover scuro del primary
  gold: '#D8C9A3', // Oro tenue, solo per dettagli minimi
  forestGreen: '#8C3D22',
  grey: '#F0EEE9'
};

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' }>`
  background: ${props => props.variant === 'secondary' ? 'transparent' : colors.primary};
  color: ${props => props.variant === 'secondary' ? colors.brown : colors.white};
  border: 1px solid ${props => props.variant === 'secondary' ? colors.brown : colors.primary};
  padding: 14px 32px;
  border-radius: 2px;
  font-size: 1rem;

  cursor: pointer;
  transition: all 0.2s ease;

  letter-spacing: 0.5px;

  &:hover {
    background: ${colors.darkRed};
    border-color: ${colors.darkRed};
    color: ${colors.white};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Card = styled.div`
  background: ${colors.white};
  border-radius: 2px;
  padding: 30px;
  border: 1px solid ${colors.secondary};
  margin-bottom: 30px;
`;

export const Section = styled.section`
  padding: 60px 0;

  @media (max-width: 768px) {
    padding: 40px 0;
  }
`;
